import { VesselCategories, VesselCategory, VesselPositionDataExtended } from '../services/types/position-service.types';
import { BaseModel } from './base-model';
import { VesselTrack } from './types/vessels-tracking-model.types';

export abstract class VesselsTrackingModelBase extends BaseModel
{
    abstract loadingPositionsPromise: Promise<void> | null;
    abstract get allVesselPositions(): Map<number, VesselPositionDataExtended>
    abstract get filteredVesselPositions(): Map<number, VesselPositionDataExtended>
    abstract get imoList(): number[];
    abstract maerskVesselEmail(imo: number): string | null;
    abstract setIMOList(imoList: number[]): Promise<void>;
    abstract getTracking(imoNo: number): VesselTrack|null;
    abstract syncTracking(imoNo: number, fromDate: Date, toDate: Date): Promise<void>;
    abstract centerMapOnVessel(): void;
    abstract _processVessels(): void;

}

let VesselsTrackingModel: VesselsTrackingModelBase|null = null;

function setVesselsTrackingModel(model: VesselsTrackingModelBase)
{
    VesselsTrackingModel = model;
}

export { VesselsTrackingModel, setVesselsTrackingModel };

// Marrine Traffic to category map. Category is the categories shown in the frontend.
// Mapping is made by Lasse Sorensen
export const categoryMap: Map<string, VesselCategory> = new Map([
    // Container (Maersk and non-maersk)
    ["Container Ship",  VesselCategories.ContainerCargo],
    ["Cargo",           VesselCategories.ContainerCargo],
            // Temporary fix: These are also container vessels, but old cached attributes. 
    ["7",               VesselCategories.ContainerCargo], // old cached 'cargo'
    ["9",               VesselCategories.ContainerCargo], // old cached 'Chemical Tanker'
    ["10",              VesselCategories.ContainerCargo], // old cached 'Container Ship'
    // Tug
    ["Inland Tug",        VesselCategories.Tug],
    ["Tug/Supply Vessel", VesselCategories.Tug],
    ["Pusher Tug",        VesselCategories.Tug],
    ["Special Tug",       VesselCategories.Tug],
    ["Tug",               VesselCategories.Tug],
    // Bulk Carrier
    ["Bulk Carrier",       VesselCategories.BulkCarrier],
    ["Heavy Load Carrier", VesselCategories.BulkCarrier],
    ["Obo Carrier",        VesselCategories.BulkCarrier],
    ["Ore Carrier",        VesselCategories.BulkCarrier],
    ["General Cargo",      VesselCategories.BulkCarrier],
    // Tanker
    ["Asphalt/Bitumen Tanker", VesselCategories.Tanker],
    ["Bunkering Tanker",       VesselCategories.Tanker],
    ["Chemical Tanker",        VesselCategories.Tanker],
    ["Crude Oil Tanker",       VesselCategories.Tanker],
    ["LNG Tanker",             VesselCategories.Tanker],
    ["LPG Tanker",             VesselCategories.Tanker],
    ["Oil Products Tanker",    VesselCategories.Tanker],
    ["Oil/Chemical Tanker",    VesselCategories.Tanker],
    ["Special Tanker",         VesselCategories.Tanker],
    ["Tanker",                 VesselCategories.Tanker],
    ["Water Tanker",           VesselCategories.Tanker],
    ["Inland Tanker",          VesselCategories.Tanker],
    ["Other Tanker",           VesselCategories.Tanker],
    // Ro-Ro
    ["Ro-Ro/Passenger Vessel", VesselCategories.RoRo],
    ["Ro-Ro/Vehicles Carrier", VesselCategories.RoRo],
]) 
